<script>
	import InputWrapper from '../InputWrapper.svelte';

	let {
		name,
		children,
		value = $bindable(),
		options = null,
		class: className = '',
		required = false,
		disabled = false,
		error = null,
		label = null,
		valueField = 'value',
		labelField = 'label',
		onchange = null,
		...props
	} = $props();

	$effect(() => {
		// Handle Boolean 'value' in a true/false dropdown
		if (
			options?.length == 2 &&
			typeof options[0].value === 'boolean' &&
			typeof options[1].value === 'boolean' &&
			typeof value === 'string'
		) {
			value = value === 'true';
		}
	});
</script>

<InputWrapper {label} {error} class={className}>
	<select
		class={[
			'w-full content-center rounded-md border-indow-grey-light',
			{ 'cursor-not-allowed bg-indow-grey-light': disabled },
			{ 'border-indow-red': error },
		]}
		aria-invalid={error ? true : undefined}
		{name}
		{value}
		{required}
		{disabled}
		{...props}
		onchange={(e) => {
			value = e.target.value;
			onchange?.(e);
		}}
	>
		{#if options}
			{#each options as option (option[valueField])}
				<option
					value={option[valueField]}
					selected={option[valueField] == value}
				>
					{option[labelField]}
				</option>
			{/each}
		{:else}
			{@render children?.()}
		{/if}
	</select>
</InputWrapper>
